// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/shared/tray-footer/tray-footer.component.scss
// module id = 187
// module chunks = 0